import AuthService from "../services/authService";

const authService = new AuthService();

// 액션 타입 정의
const USER_LOGIN = "userReducer/USER_LOGIN";
const USER_LOGOUT = "userReducer/USER_LOGOUT";

// 액션 생성 함수

const userLogin = (userData) => {
  return {
    type: USER_LOGIN,
    userData,
  };
};
const userLogout = () => {
  return {
    type: USER_LOGOUT,
  };
};

// 새로고침되어 들어온 페이지에서 로그인이 되었는지 확인하는 로직
// 로그인이 되었으면 state를 로그인되게 만들고 , 아니면 냅두고..
// 이런식으로 Thunk 를 사용해도 되는건가?

// 아 미들웨어를 왜 사용하나를 다시 찾아보면 답이 될 수도
// 디스패치를 끊어주거나 또 다른 디스패치를 일으키거나 등등 에 해당한다.

export const userLoginCheckThunk = () => {
  return (dispatch) => {
    authService.onAuthChange((user) => {
      if (user) {
        dispatch(userLogin(user));
      }
    });
  };
};

export const userLoginThunk = () => {
  return async (dispatch) => {
    try {
      const response = await authService.login();
      dispatch(userLogin(response.user));
    } catch (error) {
      alert("로그인을 취소하였습니다.");
      console.log(error);
    }
  };
};

export const userLogoutThunk = () => {
  return (dispatch) => {
    try {
      authService.logout();
      dispatch(userLogout());
    } catch (error) {
      console.log(error);
    }
  };
};

// 초기값
const initialState = { userName: null, userId: null, loggedIn: false };

// 리듀서 함수

const userReducer = (prevState = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN:
      return {
        userName: action.userData.displayName,
        userId: action.userData.uid,
        loggedIn: true,
      };
    case USER_LOGOUT:
      return {
        userName: null,
        userId: null,
        loggedIn: false,
      };
    default:
      return prevState;
  }
};

export default userReducer;
